<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.3714 2.21163L12 2L11.6286 2.21163L5.37865 5.7735L5 5.98929V6.42511V13.5684V14.0039L5.37825 14.2198L11.6283 17.7866L12 17.9988L12.3717 17.7866L18.6217 14.2198L19 14.0039V13.5684V6.42511V5.98929L18.6214 5.7735L12.3714 2.21163ZM6.5 7.71891V13.1329L11.25 15.8437V10.4346L6.5 7.71891ZM17.5 13.1329L12.75 15.8437V10.4346L17.5 7.71892V13.1329ZM16.7381 6.4267L12 3.72649L7.26195 6.42669L12 9.13556L16.7381 6.4267ZM3.49994 9.63872C2.2676 10.8708 1.50244 12.4133 1.50244 14.1266C1.50244 16.3342 2.77282 18.2582 4.6761 19.5999C5.75692 20.3619 7.05895 20.9513 8.49976 21.3188V23.0002L13 20.5002L8.49976 18.0002V19.7642C7.3751 19.4375 6.37143 18.9598 5.54037 18.374C3.91474 17.2279 3.00244 15.7152 3.00244 14.1266C3.00244 13.4383 3.17366 12.7643 3.49994 12.1282V9.63872ZM14.9984 19.8993C16.3294 19.5766 17.511 19.0466 18.4651 18.374C20.0907 17.2279 21.003 15.7152 21.003 14.1266C21.003 13.4344 20.8299 12.7566 20.4999 12.1173V9.63312C21.7356 10.8661 22.503 12.4107 22.503 14.1266C22.503 16.3342 21.2327 18.2582 19.3294 19.5999C18.1231 20.4503 16.6412 21.0858 14.9984 21.4377V19.8993Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
